import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoriesSection from './components/CategoriesSection';
import FeaturesSection from './components/FeaturesSection';
import BeginnerSection from './components/BeginnerSection';
import GuidesSection from './components/GuidesSection';
import FaqSection from './components/FaqSection';
import FinalCta from './components/FinalCta';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CategoriesSection />
        <FeaturesSection />
        <BeginnerSection />
        <GuidesSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}